import React from "react";

const TagIcon = ({ width = 14, height = 15 ,color = "none", className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 15"
    fill="none"
  >
    <path
      d="M6.83491 9.86024C8.24631 9.86024 9.39047 8.61659 9.39047 7.08247C9.39047 5.54834 8.24631 4.30469 6.83491 4.30469C5.42352 4.30469 4.27936 5.54834 4.27936 7.08247C4.27936 8.61659 5.42352 9.86024 6.83491 9.86024Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.39048 4.3054V8.91251C9.39048 10.2938 11.4669 10.5321 12.5656 8.66451C13.4971 7.08407 13.2687 4.6734 12.1052 3.08762C10.3932 0.75251 6.43493 -0.120379 3.56026 1.8094C0.917594 3.58362 -0.0228498 7.17207 1.43671 10.0725C2.88115 12.9427 6.27226 14.3338 9.34159 13.2956"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default TagIcon;
